<template>
    <span>
        You've made
        <a href="/friends"
           class="btn btn-success btn--change-count">
            {{ count }}
        </a>
        {{ plural('friend', count) }}.
    </span>
</template>

<script>
export default {
    props: {
        count: {
            type: Number,
            required: true,
        },
    },
};
</script>
